var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('of-label', {
    attrs: {
      "text": _vm.label
    }
  }), _vm._v(" "), _c('select', {
    staticClass: "form-control input-sm",
    attrs: {
      "multiple": _vm.isMultiple,
      "readonly": _vm.select.readonly || false
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a21ed55","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fields/select/Select.vue
// module id = 557
// module chunks = 1